import React from "react"
import {
  paginationWrapper,
  paginationNumbersContainer,
  activeLink,
} from "./pagination.module.scss"
import PropTypes from "prop-types"
import {
  paginationNumPageLength,
  paginationCurrentPageLength,
  paginationCurrentPageLengthElse,
  paginationCurrentPageLengthElseIf,
} from "../../constants"
import { Nav } from "./pagination-styled"
import TransitionFade from "../transition-fade"

const Pagination = ({ numPages, currentPage, contextPage }) => {
  if (numPages <= 1) {
    return null
  }
  // for each templates, entity property passed in pageContext will be different
  let baseLink = contextPage ? contextPage : ""
  const { startPage, endPage } = defineRange(currentPage, numPages)
  if (baseLink.charAt(0) === "/") {
    baseLink = baseLink.substring(1)
  }
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const prevPage =
    currentPage - 1 === 1
      ? `/${baseLink}`
      : `/${baseLink}/page/${(currentPage - 1).toString()}`
  const nextPage = `/${baseLink}/page/${(currentPage + 1).toString()}`
  return (
    <Nav className={paginationWrapper}>
      <ul className={paginationNumbersContainer}>
        {!isFirst && (
          <>
            <li>
              <TransitionFade link={`/${baseLink}`}>&lt;&lt;</TransitionFade>
            </li>
            <li>
              <TransitionFade link={prevPage}>&lt;</TransitionFade>
            </li>
          </>
        )}
        {Array.from({ length: numPages })
          .slice(startPage, endPage)
          .map((element, indx) => {
            const index = indx + startPage + 1
            const link =
              index === 1 ? `/${baseLink}` : `/${baseLink}/page/${index}`
            return (
              <li key={link}>
                {currentPage === index ? (
                  <span className={activeLink}>{index}</span>
                ) : (
                  <TransitionFade link={link}>{index}</TransitionFade>
                )}
              </li>
            )
          })}
        {!isLast && (
          <>
            <li>
              <TransitionFade link={nextPage}>&gt;</TransitionFade>
            </li>
            <li>
              <TransitionFade link={`/${baseLink}/page/${endPage}`}>
                &gt;&gt;
              </TransitionFade>
            </li>
          </>
        )}
      </ul>
    </Nav>
  )
}

function defineRange(currentPage, numPages) {
  let endPage
  let startPage
  if (numPages <= paginationNumPageLength) {
    // less than 10 total pages, show all
    startPage = 0
    endPage = numPages
  } else if (currentPage <= paginationCurrentPageLength) {
    startPage = 0
    endPage = paginationNumPageLength
  } else if (currentPage + paginationCurrentPageLengthElseIf >= numPages) {
    startPage = numPages - paginationNumPageLength
    endPage = numPages
  } else {
    startPage = currentPage - paginationCurrentPageLengthElse
    endPage = currentPage + paginationCurrentPageLengthElseIf
  }

  return { startPage, endPage }
}

//-----------------------Prop-Types---------------------------//

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  numPages: PropTypes.number.isRequired,
  contextPage: PropTypes.any,
}

//-----------------------Prop-Types---------------------------//

export default Pagination
